export const styles = {
  tabsWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    marginBottom: 20,

    position: 'relative',
    zIndex: 50,
  },

  filtersRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'flex-end',
    marginBottom: 20,

    position: 'relative',
    zIndex: 50,
  },
  tabBtn: (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    border: 'none',
    background: 'transparent',
    padding: '8px 12px',
    cursor: 'pointer',
    borderBottom: active ? '3px solid #0D47A1' : '3px solid transparent',
  }),
  tabLabel: (active) => ({
    fontSize: 14,
    fontWeight: active ? 600 : 400,
    color: active ? '#111827' : '#6B7280',
  }),
  tabBadge: (active) => ({
    minWidth: 24,
    height: 24,
    borderRadius: 999,
    padding: '0 8px',
    fontSize: 12,
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: active ? '#0D47A1' : '#E5E7EB',
    color: active ? '#FFFFFF' : '#111827',
  }),

  filtersRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'flex-end',
    marginBottom: 20,
  },
  searchInput: {
    width: '100%',
    height: 40,
    borderRadius: 10,
    border: '1px solid #E5E7EB',
    padding: '0 12px',
    fontSize: 14,
    outline: 'none',
  },
  selectLabel: {
    marginBottom: 4,
    display: 'block',
    fontSize: 12,
    color: '#6B7280',
    fontWeight: 500,
  },
  select: {
    height: 40,
    borderRadius: 10,
    border: '1px solid #E5E7EB',
    padding: '0 10px',
    fontSize: 14,
    outline: 'none',
    background: '#fff',
  },

  itemCard: (status) => {
    const base = {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 24,
      borderRadius: 16,
      padding: '20px 24px',
      marginBottom: 16,
      border: '1px solid #E5E7EB',
      backgroundColor: '#FFFFFF',
    };

    if (status === 'link') return base;

    if (status === 'pending') {
      return {
        ...base,
        backgroundColor: '#FFF8EE',
        border: '1px solid #FFE0B2',
      };
    }

    if (status === 'answered') {
      return {
        ...base,
        backgroundColor: '#FFFFFF',
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      };
    }

    return base;
  },

  itemLeft: {
    display: 'flex',
    gap: 14,
    minWidth: 0,
  },

  itemIcon: (status) => {
    const base = {
      width: 40,
      height: 40,
      borderRadius: 12,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    };

    if (status === 'answered') {
      return {
        ...base,
        backgroundColor: '#E7F7EE',
        color: '#16A34A',
      };
    }

    if (status === 'pending') {
      return {
        ...base,
        backgroundColor: '#FFE8B0',
        color: '#111827',
      };
    }

    return {
      ...base,
      backgroundColor: '#EEF2FF',
      color: '#111827',
    };
  },

  itemContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 0,
  },

  itemTitle: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 600,
    color: '#111827',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  recurringPill: {
    fontSize: 12,
    fontWeight: 700,
    padding: '4px 12px',
    borderRadius: 999,
    border: '1px solid #93C5FD',
    background: '#EFF6FF',
    color: '#1C4B75',
    flexShrink: 0,
  },
  annulledPill: {
    fontSize: 12,
    fontWeight: 700,
    padding: '4px 12px',
    borderRadius: 999,
    border: '1px solid #FECACA',
    background: '#FEF2F2',
    color: '#B91C1C',
    flexShrink: 0,
  },
  activePill: {
    fontSize: 12,
    fontWeight: 700,
    padding: '4px 12px',
    borderRadius: 999,
    border: '1px solid #A7F3D0',
    background: '#ECFDF5',
    color: '#047857',
    flexShrink: 0,
  },
  responseOriginPill: (origin) => ({
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.04em',
    padding: '3px 10px',
    borderRadius: 999,
    border: '1px solid',
    ...(origin === 'external'
      ? { color: '#1D4ED8', backgroundColor: '#EFF6FF', borderColor: '#BFDBFE' }
      : { color: '#15803D', backgroundColor: '#F0FDF4', borderColor: '#BBF7D0' }),
    flexShrink: 0,
  }),

  itemDesc: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: '18px',
  },

  vehiclePill: {
    marginTop: 6,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    borderRadius: 999,
    backgroundColor: '#F3F4F6',
    fontSize: 12,
    color: '#374151',
    width: 'fit-content',
  },

  metaRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    marginTop: 10,
    fontSize: 13,
    color: '#4B5563',
  },
  metaStatus: (isExpired) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    color: isExpired ? '#F59E0B' : '#16A34A',
    fontWeight: 600,
  }),

  dueLabel: (status) => ({
    fontWeight: 600,
    color: status === 'answered' ? '#16A34A' : '#F59E0B',
  }),

  requestedText: {
    marginTop: 8,
    fontSize: 12,
    color: '#6B7280',
  },

  linkInfo: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 2,
  },


  actionBtnInner: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 14,
    fontWeight: 600,
  },

  itemLeft: {
    display: 'flex',
    gap: 14,
    minWidth: 0,
    flex: 1,
  },

  itemContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 0,
    flex: 1, 
  },

  viewBtn: {
    paddingLeft: 12,
    paddingRight: 12,
  },

  linkCard: {
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    padding: 16,
    marginBottom: 14,
    background: '#FFFFFF',

    position: 'relative',
    zIndex: 1,
  },

  linkHeaderRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 10,
  },

  linkTitleRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    minWidth: 0,
    flex: 1,
  },

  linkIconWrap: {
    width: 28,
    height: 28,
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    background: '#F9FAFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#6B7280',
  },

  linkTitleLine: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
  },

  linkTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: '#111827',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  linkSubtitle: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 2,
  },

  linkPlateSummary: {
    fontSize: 12,
    fontWeight: 600,
    color: '#374151',
    marginTop: 4,
  },

  statusPill: (status) => ({
    fontSize: 11,
    fontWeight: 700,
    padding: '2px 10px',
    borderRadius: 999,
    border: '1px solid',
    ...(status === 'expired'
      ? { color: '#B91C1C', background: '#FEF2F2', borderColor: '#FECACA' } 
      : status === 'closed'
      ? { color: '#374151', background: '#F3F4F6', borderColor: '#E5E7EB' } 
      : { color: '#047857', background: '#ECFDF5', borderColor: '#A7F3D0' }),
    flexShrink: 0,
  }),

  kebabBtn: {
    width: 32,
    height: 32,
    borderRadius: 10,
    border: '1px solid #E5E7EB',
    background: '#FFFFFF',
    cursor: 'pointer',
    color: '#6B7280',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  linkInfoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    gap: 10,
    marginBottom: 10,
  },

  infoStrip: {
    background: '#F9FAFB',
    borderRadius: 10,
    padding: '10px 12px',
    minHeight: 48,
    border: '1px solid #F3F4F6',
  },

  infoTop: {
    fontSize: 10,
    color: '#6B7280',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    marginBottom: 4,
  },

  infoIco: {
    fontSize: 14,
    color: '#9CA3AF',
  },

  infoBottom: {
    fontSize: 12,
    fontWeight: 700,
    color: '#111827',
  },

  infoSub: {
    fontSize: 11,
    color: '#6B7280',
    marginTop: 4,
  },

  originLink: {
    color: '#1D4ED8',
    textDecoration: 'underline',
    textDecorationColor: '#1D4ED8',
    textUnderlineOffset: 2,
    fontWeight: 600,
  },

  infoBottomExpire: (status) => ({
    fontSize: 12,
    fontWeight: 700,
    color: status === 'expired' ? '#B91C1C' : status === 'closed' ? '#6B7280' : '#111827',
  }),

  linkRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    border: '1px solid #E5E7EB',
    borderRadius: 10,
    padding: '8px 10px',
    background: '#FFFFFF',
    marginBottom: 12,
  },

  linkInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: 12,
    color: '#6B7280',
    background: 'transparent',
  },

  copyBtn: {
  width: 34,
  height: 34,
  borderRadius: 10,
  border: '1px solid #E5E7EB',
  backgroundColor: '#FFFFFF',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
},

copyBtnCopied: {
  width: 34,
  height: 34,
  borderRadius: 10,
  border: '1px solid #D1FAE5',
  backgroundColor: '#F9FAFB',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
},

copyIcon: {
  fontSize: 18,
  color: '#6B7280',
},

copyIconCopied: {
  fontSize: 20,
  color: '#10B981',
},

linkFooter: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
},

viewAnswersBtn: {
  border: '1px solid #E5E7EB',
  backgroundColor: '#FFFFFF',
  color: '#374151',
  borderRadius: 10,
  padding: '8px 14px',
  height: 36,
  minHeight: 36,
},

viewAnswersInner: {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  fontWeight: 600,
  fontSize: 14,
},

viewAnswersBtnHover: {
  backgroundColor: '#F3F4F6',
},

kebabWrap: {
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
},

kebabBtn: {
  width: 32,
  height: 32,
  borderRadius: 10,
  border: '1px solid transparent',
  backgroundColor: 'transparent',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
},

kebabMenu: {
  position: 'absolute',
  top: 30,
  right: 0,
  width: 220,
  backgroundColor: '#FFFFFF',
  border: '1px solid #E5E7EB',
  borderRadius: 12,
  boxShadow: '0 10px 20px rgba(0,0,0,0.10)',
  padding: 6,
  zIndex: 60,
},

kebabItem: {
  width: '100%',
  border: 0,
  background: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 12px',
  borderRadius: 10,
  fontSize: 14,
  color: '#111827',
  textAlign: 'left',
},

kebabItemDanger: {
  width: '100%',
  border: 0,
  background: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 12px',
  borderRadius: 10,
  fontSize: 14,
  color: '#F97316', 
  textAlign: 'left',
},

kebabIcon: {
  fontSize: 18,
  color: '#6B7280',
},

kebabIconDanger: {
  fontSize: 18,
  color: '#9CA3AF',
},

};
